import { Pipe, PipeTransform } from '@angular/core';
import { UploadFileService } from 'src/app/shared/providers/upload-file.service';

@Pipe({
  name: 'uploadProgress',
  pure: false
})
export class UploadProgressPipe implements PipeTransform {
  constructor(private uploadService: UploadFileService) {}

  transform(collectionId?: string | null): string | null {
    const status = this.uploadService.getStorageUploadStatusForCollection(collectionId);
    if (!status) {
      return null;
    }
    const remainingLabel = this.formatRemainingSize(status.remainingBytes);
    return remainingLabel;
  }

  private formatRemainingSize(bytes: number): string {
    const safeBytes = Number.isFinite(bytes) && bytes > 0 ? bytes : 0;
    const bytesInMb = 1024 * 1024;
    const bytesInGb = bytesInMb * 1024;

    const useGb = safeBytes >= bytesInGb;
    const value = safeBytes / (useGb ? bytesInGb : bytesInMb);
    if (useGb) {
      const roundedGb = Math.round(value * 10) / 10;
      const formattedGb = roundedGb.toFixed(1);
      return `${formattedGb} GB`;
    }
    const roundedMb = Math.round(value);
    return `${roundedMb} MB`;
  }
}
